export const HERO_VIDEO_MOBILE_MEDIA = "(max-width: 991px)";
/** Transparent 1×1 GIF — baseline poster so CSS `--hero-poster` backgrounds show through. */
export const HERO_VIDEO_BASELINE_POSTER = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
export function isHeroMobileViewport() {
    return window.matchMedia(HERO_VIDEO_MOBILE_MEDIA).matches;
}
export function selectHeroVideoSource(desktopUrl, mobileUrl) {
    if (mobileUrl && isHeroMobileViewport()) {
        return mobileUrl;
    }
    return desktopUrl;
}
/**
 * Picks desktop or mobile URL from data attributes and loads it on the video element.
 * Browsers ignore media on <source> inside <video>, so source selection must be explicit.
 */
export function applyHeroVideoSource(video) {
    const src = selectHeroVideoSource(video.getAttribute("data-src-video"), video.getAttribute("data-src-video-mobile"));
    if (!src) {
        return false;
    }
    const resolved = new URL(src, document.baseURI).href;
    if (video.currentSrc === resolved || video.src === resolved) {
        return false;
    }
    video.querySelectorAll("source").forEach((source) => source.remove());
    video.src = src;
    video.load();
    return true;
}
const CLOUDFLARE_MEDIA_MARKER = "/cdn-cgi/media/";
function isLoadingCloudflareMedia(video) {
    if ((video.getAttribute("src") ?? "").includes(CLOUDFLARE_MEDIA_MARKER)) {
        return true;
    }
    return Array.from(video.querySelectorAll("source")).some((source) => (source.getAttribute("src") ?? "").includes(CLOUDFLARE_MEDIA_MARKER));
}
/**
 * Swaps a failed Cloudflare Media Transformation (unsupported codec, input over 100 MB, transform
 * error) back to the original CMS file the server rendered in data-src-video-original.
 * Only reacts when the failing source is a /cdn-cgi/media/ URL, so the empty lazy <source>
 * placeholder and failures of the original file itself never trigger a reload.
 */
export function attachHeroVideoFallback(video) {
    const originalDesktop = video.getAttribute("data-src-video-original");
    if (!originalDesktop) {
        return () => { };
    }
    const fallback = () => {
        if (!isLoadingCloudflareMedia(video)) {
            return;
        }
        const originalMobile = video.getAttribute("data-src-video-mobile-original");
        video.setAttribute("data-src-video", originalDesktop);
        if (originalMobile) {
            video.setAttribute("data-src-video-mobile", originalMobile);
        }
        else {
            video.removeAttribute("data-src-video-mobile");
        }
        if (applyHeroVideoSource(video)) {
            void video.play().catch(() => { });
        }
    };
    // <source> errors do not bubble, so listen in the capture phase.
    video.addEventListener("error", fallback, true);
    // The transform may already have failed before hydration (above-fold <source> or inline src).
    if (video.error || video.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) {
        fallback();
    }
    return () => video.removeEventListener("error", fallback, true);
}
export function applyHeroVideoPoster(video, wrapper) {
    const mobilePoster = video.getAttribute("data-poster-mobile") ||
        wrapper?.getAttribute("data-poster-mobile") ||
        video.parentElement?.closest("[data-poster-mobile]")?.getAttribute("data-poster-mobile");
    if (mobilePoster && isHeroMobileViewport()) {
        video.poster = mobilePoster;
    }
    else {
        video.poster = HERO_VIDEO_BASELINE_POSTER;
    }
}
